import vocabulariesTab from './vocabulariesTab';

export default [
  vocabulariesTab,
];
